// src/line/pages/allBookListLine.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import useLineAuth from '../hooks/useLineAuth';
import { auth } from '../../firebase/firebase';

import usePublicQueue from '../../shared/hooks/usePublicQueue';
import PublicQueueList from '../../shared/components/PublicQueueList';
import LoadingCard from '../../shared/components/LoadingCard';

export default function LineAll() {
  // 1) LINE 認証情報
  const { error, lineUserId } = useLineAuth();

  // 2) Firebase Auth のログイン完了待ち
  const [authReady, setAuthReady] = useState(false);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, () => setAuthReady(true));
    return () => unsub();
  }, []);


  // LINE版は「自分のIDが string になるまで」描画しない（= チラつき防止）
  const myIdResolved = (typeof lineUserId === 'string') || !!error; // エラー時は進める

  // フック自体は常に呼ぶ（順序を守るため）。userId は確定後に渡る。
  const queue = usePublicQueue({
    userId: (typeof lineUserId === 'string') ? lineUserId : null,
    userIdField: 'lineId',
  });
  
  const loading =
    !authReady ||
    !myIdResolved ||                                   // ← まずは自分のIDが確定するまで待つ
    !queue.runtimeReady ||
    (queue.inhouseOn === true && (
      !queue.rowsReady ||                              // 一覧の初回応答を待つ
      (typeof lineUserId === 'string' && !queue.mineResolved) // 自分行の特定が完了するまで待つ
    ));


  // 8) 画面分岐
  if (error) {
    return (
      <div className="line-container">
        <div className="line-card">
          <h1 className="line-title">認証エラー</h1>
          <p className="line-desc">LINEからアクセスし直してください。</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="line-container">
        <LoadingCard />
      </div>
    );
  }

  return (
    <PublicQueueList
      inhouseOn={queue.inhouseOn}
      waitCount={queue.waitCount}
      nowStr={queue.nowStr}
      list={queue.list || []}
      myAheadCount={queue.myAheadCount}
      showMineBadge={true}
    />
  );
}
